"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminListingDtoListingStatusEnum = exports.AdminListingDtoCampaignEnum = exports.AdminListingDtoListingTypeEnum = void 0;
exports.instanceOfAdminListingDto = instanceOfAdminListingDto;
exports.AdminListingDtoFromJSON = AdminListingDtoFromJSON;
exports.AdminListingDtoFromJSONTyped = AdminListingDtoFromJSONTyped;
exports.AdminListingDtoToJSON = AdminListingDtoToJSON;
exports.AdminListingDtoToJSONTyped = AdminListingDtoToJSONTyped;
var SellerVendorDto_1 = require("./SellerVendorDto");
/**
 * @export
 */
exports.AdminListingDtoListingTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction',
    ReverseAuction: 'reverse_auction'
};
/**
 * @export
 */
exports.AdminListingDtoCampaignEnum = {
    VendorManaged: 'vendor_managed',
    UnreservedManaged: 'unreserved_managed'
};
/**
 * @export
 */
exports.AdminListingDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * Check if a given object implements the AdminListingDto interface.
 */
function instanceOfAdminListingDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('propertyTitle' in value) || value['propertyTitle'] === undefined)
        return false;
    if (!('location' in value) || value['location'] === undefined)
        return false;
    if (!('listingType' in value) || value['listingType'] === undefined)
        return false;
    if (!('campaign' in value) || value['campaign'] === undefined)
        return false;
    if (!('totalEnquiries' in value) || value['totalEnquiries'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('hideProperty' in value) || value['hideProperty'] === undefined)
        return false;
    if (!('vendors' in value) || value['vendors'] === undefined)
        return false;
    if (!('coVendors' in value) || value['coVendors'] === undefined)
        return false;
    if (!('agents' in value) || value['agents'] === undefined)
        return false;
    return true;
}
function AdminListingDtoFromJSON(json) {
    return AdminListingDtoFromJSONTyped(json, false);
}
function AdminListingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'propertyTitle': json['propertyTitle'],
        'propertyImage': json['propertyImage'] == null ? undefined : json['propertyImage'],
        'location': json['location'],
        'listingType': json['listingType'],
        'campaign': json['campaign'],
        'totalEnquiries': json['totalEnquiries'],
        'price': json['price'] == null ? undefined : json['price'],
        'startingBidPrice': json['startingBidPrice'] == null ? undefined : json['startingBidPrice'],
        'reservePrice': json['reservePrice'] == null ? undefined : json['reservePrice'],
        'listingStatus': json['listingStatus'],
        'updatedAt': json['updatedAt'],
        'createdAt': json['createdAt'],
        'hideProperty': json['hideProperty'],
        'vendors': (json['vendors'].map(SellerVendorDto_1.SellerVendorDtoFromJSON)),
        'coVendors': (json['coVendors'].map(SellerVendorDto_1.SellerVendorDtoFromJSON)),
        'agents': (json['agents'].map(SellerVendorDto_1.SellerVendorDtoFromJSON)),
    };
}
function AdminListingDtoToJSON(json) {
    return AdminListingDtoToJSONTyped(json, false);
}
function AdminListingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'propertyTitle': value['propertyTitle'],
        'propertyImage': value['propertyImage'],
        'location': value['location'],
        'listingType': value['listingType'],
        'campaign': value['campaign'],
        'totalEnquiries': value['totalEnquiries'],
        'price': value['price'],
        'startingBidPrice': value['startingBidPrice'],
        'reservePrice': value['reservePrice'],
        'listingStatus': value['listingStatus'],
        'updatedAt': value['updatedAt'],
        'createdAt': value['createdAt'],
        'hideProperty': value['hideProperty'],
        'vendors': (value['vendors'].map(SellerVendorDto_1.SellerVendorDtoToJSON)),
        'coVendors': (value['coVendors'].map(SellerVendorDto_1.SellerVendorDtoToJSON)),
        'agents': (value['agents'].map(SellerVendorDto_1.SellerVendorDtoToJSON)),
    };
}
